module.exports = __webpack_public_path__ + "img/home-of-sports.c2322793.jpg";